/// <amd-module name="Core/Medius.Core.Web/Scripts/components/readonlyTabs/reasonCodes"/>
import * as React from 'react';
import { IDocumentImportInformation, ReasonCodeDto } from "../interfaces";
import { Text } from '@medius/ui-controls';
import { translate } from 'Core/Medius.Core.Web/Scripts/lib/globalization';

interface ReasonCodesProps {
    information: IDocumentImportInformation;
}

export const isAnyReasonCodesNotEmpty = (information: IDocumentImportInformation): boolean =>
    information?.reasonCodes !== null && information?.reasonCodes !== undefined && information.reasonCodes.length > 0;

export const ReasonCodesDetails = (props: ReasonCodesProps) => {
    return (
        <>
            {props.information?.reasonCodes?.map((reasonCode: ReasonCodeDto, index: number) => (
                <div key={`reason-code-${index}`} style={{ marginBottom: '16px' }}>
                    <Text variant={'body'}><b>{reasonCode.reasonCodeName || '-'}</b> {translate("#PurchaseToPay/documentReasonCodes/document/reasonCodeAddedBy")} <b>{reasonCode.userName || '-'}</b></Text>
                </div>
            ))}
        </>
    );
};